var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPrinciple5(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 95,
    height: 94,
    viewBox: "0 0 95 94",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1377_236)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M61.1238 87.4419H35.3486V94H61.1238V87.4419Z",
    fill: "#F6A000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.1238 77.6045H35.3486V84.1626H61.1238V77.6045Z",
    fill: "#F6A000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.4161 58.9648C68.5327 54.7967 71.0661 49.0984 71.0661 42.8099C71.0661 29.4896 59.6882 18.7998 46.0273 19.7325C34.5905 20.5122 25.282 29.6207 24.3761 40.9299C23.7796 48.4499 26.8137 55.2849 31.932 59.9048C34.156 61.9159 35.349 64.8161 35.349 67.7964V74.3254H61.1242V67.7672V66.7325C61.1242 63.8105 62.3541 61.0561 64.4161 58.9648ZM41.9622 67.7672C41.8149 62.7903 39.5761 58.1559 35.9676 54.6583C35.7541 54.4542 35.5479 54.2429 35.349 54.0243C32.1823 50.6213 30.437 45.8995 31.0482 40.7914C31.9541 33.235 38.1327 27.1724 45.7769 26.3417C55.8808 25.2414 64.4382 33.0382 64.4382 42.8172C64.4382 46.5262 63.2083 49.951 61.1242 52.7127C60.7118 53.2592 60.2626 53.7838 59.7839 54.2793C56.411 57.7624 54.4963 62.3823 54.4963 67.2062V67.7672H41.9622Z",
    fill: "#F6A000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.998 15.3023V0L44.3701 0V15.3023H50.998Z",
    fill: "#F6A000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.5349 49.5503H95V42.9922H79.5349V49.5503Z",
    fill: "#F6A000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4651 42.9922H0V49.5503H15.4651V42.9922Z",
    fill: "#F6A000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.4927 26.1729L83.4282 15.3525L78.7416 10.7152L67.8061 21.5356L72.4927 26.1729Z",
    fill: "#F6A000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5073 66.3617L11.5718 77.1821L16.2584 81.8194L27.1939 70.9991L22.5073 66.3617Z",
    fill: "#F6A000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.1918 21.5455L16.2563 10.7251L11.5697 15.3624L22.5052 26.1828L27.1918 21.5455Z",
    fill: "#F6A000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.8082 71.0048L78.7437 81.8252L83.4303 77.1879L72.4948 66.3675L67.8082 71.0048Z",
    fill: "#F6A000"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1377_236"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 95,
    height: 94,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrinciple5);
export default __webpack_public_path__ + "static/media/principle_5.086d0bf4cf84e5914d843164d6aedd0f.svg";
export { ForwardRef as ReactComponent };